import {ValidationResponseEnum} from "../Enums/ValidationResponseEnum";
import MessageLogModel from "./MessageLogModel";

export default class AuthProviderValidationModel {
    validation: ValidationResponseEnum = null;
    message: MessageLogModel = new MessageLogModel();
    getIdToken: any = { validation: null, message: new MessageLogModel() };
    logout: any = { validation: null, message: new MessageLogModel() };
}
